import React from "react";

// eslint-disable-next-line react/display-name
const Loading = React.memo(() => {
    return (
        <div className="d-flex justify-content-center">
            <div
                style={{ width: "10rem", height: "10rem" }}
                className="mt-5 spinner-grow"
                role="status"
            >
                <span className="sr-only">Loading...</span>
            </div>
        </div>
    );
});

export default Loading;
